import base from './base';

const intercomAPI = base.injectEndpoints({
  endpoints: (build) => ({
    getIntercomUserJwt: build.query<{ token: string }, void>({
      query: () => ({
        url: `/v2/intercom/user-jwt`,
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export default intercomAPI;
